import React, {Component} from "react";
import {Redirect } from 'react-router-dom';
import {FaSignInAlt, FaLock, FaUser, FaEye} from "react-icons/fa";
import {Row, Col, Form, Button, Spinner, Image} from "react-bootstrap";


export default class AboutUS extends Component {
    render() { 
      return (
        <div id="page-login" className='h100 form-body' style={{  backgroundColor:  "#45b698" }}>
            <Row>
                <Col lg='4' className="pl-0 pr-0"><div className="bg-image-noImage"><Image src={`${process.env.PUBLIC_URL}/img/Icon2.png`} style={{width: "70px"}} /></div></Col>
                <Col lg='8' className="pl-0 pr-0">
                    <div className="form-holder">
                        <div className="form-content" style={{ borderRadius: "0px", backgroundColor:  "#45b698", color: "#000" }}>
                          <Form className="form text-center"  >
                                <div className="align-items-center mt-3 pt-3 mb-3 pb-3">
                                    <div className="sidebar-brand-text"></div>
                                </div>
                            
                            
                                  <h2 className="text-center w-100"><b>About US</b></h2>
                                  <div className=" text-center">
                                      <p>We are continuously thriving to enable software solutions, in the field of Oncology. Making it possible to take it to the next level. Our goal is to help Doctors to be able to better serve their Patients, ensuring personal care tailored with quality services. 

                                    We are on a journey to bridge the gap between the human touch and the technology, with our solutions. Our objective is to build world class solutions to help human-kind.</p>
                                  </div>
                            </Form>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
      )
    }
}